import { DataItem, PlainDataProvider } from 'modules/data-providers';
import { memo, PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { useGetNetSuiteCountries } from 'shared/data/webApp/v1';

const NetSuiteCountriesDataProvider = memo<PropsWithChildren>((props) => {
    const { children } = props;

    const [items, setItems] = useState<DataItem[]>([]);

    const { data, isFetching } = useGetNetSuiteCountries();

    useEffect(() => {
        if (!data) {
            return;
        }

        setItems(
            data?.values.map((country) => ({
                id: country.key,
                text: country.value,
            })) || []
        );
    }, [data]);

    const filterCountries = useCallback((item: DataItem, filterText: string | null) => {
        if (!filterText) {
            return true;
        }

        const processedFitlerText = filterText.split(' ').join('').toUpperCase();

        return (
            item.id.toUpperCase().includes(processedFitlerText) ||
            Boolean(item.text?.toUpperCase().includes(processedFitlerText))
        );
    }, []);

    return (
        <PlainDataProvider items={items} filterFn={filterCountries} loading={isFetching}>
            {children}
        </PlainDataProvider>
    );
});

export default NetSuiteCountriesDataProvider;
